import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import Topbar from '../topbar/topbar'
import Sidebar from '../sidebar/sidebar'
import Footer from '../footer/footer'
import { connect } from 'react-redux'
import { fetchDashboardDetails } from '../../redux/actions/ticket';
import { allEngineers, logoutUser } from '../../redux/actions/user';
import { withAuth } from '../withAuth';
//import CanvasJSReact from '../../canvas/canvasjs.react';
//var CanvasJSChart = CanvasJSReact.CanvasJSChart;
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
// Support Chart.js v2 and v3 registration styles
if ((Chart as any)?.register) {
  (Chart as any).register(ChartDataLabels);
} else {
  (Chart as any)?.plugins?.register?.(ChartDataLabels);
}
class PieChart extends Component<{ data: any }, {}> {
  constructor(readonly props: any) {
      super(props);
  }
  chartInstance: Chart | null = null;

  componentDidMount() {
    this.renderChart();
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.data === this.props.data) {
      return;
    }
    this.destroyChart();
    this.renderChart();
  }

  componentWillUnmount() {
    this.destroyChart();
  }

  destroyChart() {
    this.chartInstance?.destroy();
    this.chartInstance = null;
  }

  extractChartData() {
    if (!this.props.data) {
      return null;
    }
    const {
      ticketsClosed = 0,
      ticketsReceived = 0,
      ticketsAssigned = 0,
      ticketsResolved = 0
    } = this.props.data;
    return [ticketsClosed, ticketsReceived, ticketsAssigned, ticketsResolved];
  }

  renderChart() {
    const dataset = this.extractChartData();
    if (!dataset) {
      return;
    }
    const canvas = document.getElementById('piechart') as HTMLCanvasElement | null;
    if (!canvas) {
      return;
    }
    this.chartInstance = new Chart(canvas, {
      type: 'pie',
      plugins: [ChartDataLabels],
      options: {
        plugins: {
          datalabels: {
            display(context: any) {
              return context.dataset.data[context.dataIndex] > 0;
            }
          }
        },
        responsive: true,
        legend: {
          position: 'bottom',
        },
        title: {
          display: true,
          text: 'Tickets',
          fontSize: 20
        }
      },
      data: {
        labels: ["Closed", "Recieved", "Assigned", "Resolved"],
        datasets: [
          {
            data: dataset,
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(54, 162, 235)',
              'rgb(255, 205, 86)',
              'rgb(34, 139, 34)'
            ],
            datalabels: {
              color: 'white',
              font: {
                size: 16,
                family: 'cursive'
              }
            }
          }
        ]
      }
    });
  }
  render() {
      return (
      <div>
          <canvas height="100" id="piechart" />
      </div>
      );
  }
}

class Dashboard extends Component<{
  dashboardDetails: any,
  engineers: any[],
  fetchDashboardDetails: () => {},
  allEngineers: () => {},
  logoutUser: () => {},
  roleId: any,
},
  { showDiv: any }> {
  constructor(readonly props: any) {
    super(props);
    this.state = { showDiv: '' }
  }
  componentDidMount() {
    this.props.fetchDashboardDetails()
    this.props.allEngineers()
    document.title = "SimplexServices | Dashboard"
  }

  render() {
    const { dashboardDetails, engineers, roleId } = this.props;

    const {
      ticketsReceived = 0,
      ticketsAssigned = 0,
      ticketsResolved = 0,
      ticketsPaused = 0,
      ticketsClosed = 0,
      ticketsTotal = 0,
      avgResponseTimeInMinutes = 0,
      avgResolutionTimeInMinutes = 0,
      avgFeedbackScore = 0,
      slaBreachCount = 0
    } = dashboardDetails || {};

    return (
      <div className="page">
        <Topbar />
        <div className="page-content d-flex align-items-stretch">
          <Sidebar />
          <div className="content-inner">
            {/* <!-- Page Header--> */}
            <header className="page-header py-0">
              <div className="container-fluid">
                <div className="d-flex justify-content-between py-3">
                  <h4 className="mt-2">Dashboard</h4>
                </div>
              </div>
            </header>
            {/* <!-- Dashboard Counts Section--> */}
            <section className="dashboard-counts no-padding-bottom">
              <div className="container-fluid">
                <div className="row bg-white has-shadow">
                  {/* <!-- Item --> */}
                  <div className="col-xl-2 col-sm-6">
                    <div className="item d-flex align-items-center" style={{ border: "none" }}>
                      {roleId === 1 || roleId === 2 || roleId === 4 || roleId === 5 ? (
                        <div className="icon bg-violet">
                          <i className="fa fa-get-pocket"></i>
                        </div>
                      ) : (
                        <div className="icon bg-violet">
                          <i className="fa fa-get-pocket"></i>
                        </div>
                      )}
                      <div className="title">
                        <span>Recieved</span><br />
                      <div className="number mr-2">
                        <strong>{ticketsReceived}</strong>
                      </div>
                        <div className="progress">
                          <div
                            role="progressbar"
                            style={{ width: `${ticketsReceived / 100}%`, height: "4px" }}
                            className="progress-bar bg-violet"
                          ></div>{" "}
                          {/*ariaValuenow="25" ariaValuemin="0" ariaValuemax="100"*/}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Item --> */}
                  <div className="col-xl-2 col-sm-6">
                    <div className="item d-flex align-items-center" style={{ border: "none" }}>
                      {roleId === 1 ||
                        roleId === 3 ||
                        roleId === 4 ||
                        roleId === 5 ? (
                        <div className="icon bg-red">
                          <i className="fa fa-users"></i>
                        </div>
                      ) : (
                        <div className="icon bg-red">
                          <i className="fa fa-users"></i>
                        </div>
                      )}
                      <div className="title">
                        <span>Assigned</span><br />
                      <div className="number mr-2">
                        <strong>{ticketsAssigned}</strong>
                      </div>
                        <div className="progress">
                          <div
                            role="progressbar"
                            style={{ width: `${ticketsAssigned / 100}%`, height: "4px" }}
                            className="progress-bar bg-red"
                          ></div>{" "}
                          {/*ariaValuenow="70" ariaValuemin="0" ariaValuemax="100"*/}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Item --> */}
                  <div className="col-xl-2 col-sm-6">
                    <div className="item d-flex align-items-center" style={{ border: "none" }}>
                      {roleId === 1 || roleId === 3 || roleId === 4 || roleId === 5 ? (
                        <div className="icon bg-orange">
                          <i className="fa fa-unlock-alt"></i>
                        </div>
                      ) : (
                        <div className="icon bg-orange">
                          <i className="fa fa-unlock-alt"></i>
                        </div>
                      )}
                      <div className="title">
                        <span>Resolved</span><br />
                      <div className="number mr-2">
                        <strong>{ticketsResolved}</strong>
                      </div>
                        <div className="progress">
                          <div
                            role="progressbar"
                            style={{ width: `${ticketsResolved / 100}%`, height: "4px" }}
                            className="progress-bar bg-orange"
                          ></div>{" "}
                          {/*ariaValuenow="50" ariaValuemin="0" ariaValuemax="100"*/}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Paused Ticket Status Start */}
                  <div className="col-xl-2 col-sm-6">
                    <div className="item d-flex align-items-center" style={{ border: "none" }}>
                      {roleId === 1 || roleId === 3 || roleId === 4 || roleId === 5 ? (
                        <div className="icon bg-yellow">
                          <i className="fa fa-pause"></i>
                        </div>
                      ) : (
                        <div className="icon bg-yellow">
                          <i className="fa fa-pause"></i>
                        </div>
                      )}
                      <div className="title">
                        <span>Paused</span><br />
                      <div className="number mr-2">
                        <strong>{ticketsPaused}</strong>
                      </div>
                        <div className="progress">
                          <div
                            role="progressbar"
                            style={{ width: `${ticketsPaused / 100}%`, height: "4px" }}
                            className="progress-bar bg-yellow"
                          ></div>{" "}
                          {/*ariaValuenow="50" ariaValuemin="0" ariaValuemax="100"*/}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Paused Ticket Status End */}

                  <div className="col-xl-2 col-sm-6">
                    <div className="item d-flex align-items-center" style={{ border: "none" }}>
                      {roleId === 1 || roleId === 3 || roleId === 4 || roleId === 5 ? (
                        <div className="icon bg-green">
                          <i className="fa fa-window-close"></i>
                        </div>
                      ) : (
                        <div className="icon bg-green">
                          <i className="fa fa-window-close"></i>
                        </div>
                      )}
                      <div className="title">
                        <span>Closed</span><br />
                      <div className="number">
                        <strong>{ticketsClosed}</strong>
                      </div>
                        <div className="progress">
                          <div
                            role="progressbar"
                            style={{ width: `${ticketsClosed / 100}%`, height: "4px" }}
                            className="progress-bar bg-green"
                          ></div>{" "}
                          {/*ariaValuenow="40" ariaValuemin="0" ariaValuemax="100"*/}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-2 col-sm-6" 
                    style={{ maxWidth: "20%" }}>
                    <div className="item d-flex align-items-center" style={{ border: "none" }}>
                      {roleId === 1 || roleId === 3 || roleId === 4 || roleId === 5 ? (
                        <div className="icon bg-green">
                          <i className="fa fa-calculator"></i>
                        </div>
                      ) : (
                        <div className="icon bg-green">
                          <i className="fa fa-calculator"></i>
                        </div>
                      )}
                      <div className="title">
                        <span>Total</span><br />
                      <div className="number">
                        <strong>{ticketsTotal}</strong>
                      </div>
                        <div className="progress">
                          <div
                            role="progressbar"
                            style={{ width: `${ticketsTotal / 100}%`, height: "4px" }}
                            className="progress-bar bg-green"
                          >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* <!-- Dashboard PieChart Section  --> */}
            <section className="dashboard-header no-padding-bottom">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12 col-12">
                    <div className="pie-chart text-white bg-white align-items-center justify-content-center has-shadow">
                      {dashboardDetails &&
                        <PieChart data={dashboardDetails} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Table Cards */}
            <section className="dashboard-header no-padding-bottom">
              <div className="container-fluid">
                <div className="row">
                  {/* <!-- Statistics --> */}

                  <div className="chart col-lg-4 col-12">
                    <div className="statistic d-flex align-items-center bg-white has-shadow">
                      <div className="icon bg-blue">
                        <i className="fa fa-user"></i>
                      </div>
                      <div className="text">
                        <strong>{engineers?.length}</strong>
                        <br />
                        <small>Active Engineers</small>
                      </div>
                    </div>
                  </div>
                  <div className="chart col-lg-4 col-12">
                    {/* <!-- Numbers--> */}
                    <div className="statistic d-flex align-items-center bg-white has-shadow">
                      <div className="icon bg-info">
                        <i className="fa fa-clock-o"></i>
                      </div>
                      <div className="text">
                        <strong>{avgResponseTimeInMinutes} mins</strong>
                        <br />
                        <small>AVG Response Time</small>
                      </div>
                    </div>
                  </div>
                  <div className="chart col-lg-4 col-12">
                    <div className="statistic d-flex align-items-center bg-white has-shadow">
                      <div className="icon bg-success">
                        <i className="fa fa-clock-o"></i>
                      </div>
                      <div className="text">
                        <strong>{avgResolutionTimeInMinutes} mins</strong>
                        <br />
                        <small>AVG Resolution Time</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="dashboard-header pt-xl-2">
              <div className="container-fluid">
                <div className="row">
                  <div className="chart col-lg-4 col-12">
                    <div className="statistic d-flex align-items-center bg-white has-shadow">
                      <div className="icon bg-orange">
                        <i className="fa fa-pause"></i>
                      </div>
                      <div className="text">
                        <strong>{ticketsPaused}</strong>
                        <br />
                        <small>Hold Tickets</small>
                      </div>
                    </div>
                  </div>
                  <div className="chart col-lg-4 col-12">
                    <div className="statistic d-flex align-items-center bg-white has-shadow">
                      <div className="icon bg-red">
                        <i className="fa fa-ban"></i>
                      </div>
                      <div className="text">
                        <strong>{slaBreachCount}</strong>
                        <br />
                        <small>SLA Breach Tickets</small>
                      </div>
                    </div>
                  </div>
                  <div className="statistics col-lg-4 col-12">
                    <div className="statistic d-flex align-items-center bg-white has-shadow">
                      <div className="icon bg-orange">
                        <i className="fa fa-comments-o"></i>
                      </div>
                      <div className="text">
                        <strong>{avgFeedbackScore}</strong>
                        <br />
                        <small>Feedback Score</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <Footer />
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state: any) => {
  // console.log("state",state);
  return {
    dashboardDetails: state.ticket.dashboardDetails,
    engineers: state.user.engineers
  }
}
const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchDashboardDetails: function () {
      dispatch(fetchDashboardDetails());
    },
    allEngineers: function () {
      dispatch(allEngineers());
    },
    logoutUser: function () {
      dispatch(logoutUser());
    },
  }
}

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(Dashboard));